<template>
  <!-- toast -->
  <AlertMsg :msg="msgObj.msg" :show="msgObj.show" :role="msgObj.role" @closePopup="msgObj.show = false" ></AlertMsg>
  <!-- end toast -->
  <div class="row">
    <div class="col-12">
      <div class="d-flex align-items-center">
        <h5 class="mb-0 text-primary"><i  class="fas fa-money-check-alt text-primary"></i> Collect Fee</h5>
      </div>
      <hr />
      <div class="row g-3">
         <div class="col-md-3">
          <label class="form-label">
            Class<sup><span class="text-danger font-12">*</span></sup> :
          </label>
          <div class="dropdown">
            <button class="form-select form-select-sm rounded dropdown-toggle w-100 dropdown-a" type="button" data-bs-toggle="dropdown" aria-expanded="false" >
              {{ clsList.find(c => c._id === Obj.ClassId)?.name || " " }}
            </button>
            <ul class="dropdown-menu w-100 scrollable-menu">
              <li v-for="(fg, index) in feeGroups" :key="index">
                <a class="dropdown-item" href="#" @click.prevent="onClassSelected(fg)">
                  {{ clsList.find(c => c._id === extractClassId(fg.ClassName))?.name || extractClassId(fg.ClassName) }}
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-md-3">
          <label class="form-label">Section:<sup><span class="text-danger font-12">*</span></sup> :</label>
          <select v-model="Obj.sectionID" class="form-select form-select-sm rounded cursor-pointer" role="button" @change="listData()">
            <option selected=""></option>
            <option v-for="(item, index) in
             secList" :key="index" :value="item._id"> {{ item.Name }} </option>
          </select>
        </div>
        <div class="col-md-3">
          <label class="form-label">Student Name<sup><span class="text-danger font-12">*</span></sup> :</label>
          <select v-model="Obj.studentID" class="form-select form-select-sm rounded cursor-pointer" role="button">
            <option selected=""></option>
            <option v-for="(item, index) in
              List1" :key="index" :value="item._id"> {{ item.firstName }}  {{ item.lastName }} </option>
          </select>
        </div>
        <div class="col-md-3">
          <label class="form-label">Date<sup><span class="text-danger font-12">*</span></sup> :</label>
          <input class="form-control form-control-sm" type="date" v-model="Obj.PayDate" />
        </div>
           <div class="col-md-3">
          <label class="form-label">Total<sup><span class="text-danger font-12">*</span></sup> :</label>
          <input type="text" class="form-control form-control-sm" v-model="Obj.Total" readonly />
        </div>
        <div class="col-md-3">
          <label class="form-label">Payable Amount<sup><span class="text-danger font-12">*</span></sup>
            :</label>
          <input class="form-control form-control-sm" type="number" v-model="Obj.PaidAmount" />
        </div>
        <div class="col-md-3">
          <label class="form-label">Transcation Id<sup><span class="text-danger font-12">*</span></sup>
            :</label>
          <input class="form-control form-control-sm" type="text" v-model="Obj.transID" />
        </div>
         <div class="col-md-3">
          <label class="form-label">Paid Type<sup><span class="text-danger font-12">*</span></sup>
            :</label>
         <select class="form-select form-select-sm rounded cursor-pointer" role="button" v-model="Obj.PaidType">
            <option selected=""></option>
            <option value="Free Amount">Free Amount</option>
            <option value="Discount Amount">Discount Amount</option>
            <option value="Actual Amount">Actual Amount</option>
          </select>
        </div>
        <div class="col-md-12">
          <label class="form-label">
            Fee Type<sup><span class="text-danger font-12">*</span></sup> :
          </label>
         <Multiselect v-model="Obj.FeeType" :options="feeOptions" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" label="Name" track-by="Name" class="form-control form-control-sm z-1" >
          <template #option="{ option }"> {{ option.Name }} 
          </template>
        </Multiselect>
        </div>
        <div class="col-md-3">
          <label class="form-label">Payment Mode<sup><span class="text-danger font-12">*</span></sup>
            :</label>
          <select class="form-select form-select-sm rounded cursor-pointer" role="button" v-model="Obj.PaymentMode">
            <option selected=""></option>
            <option value="GPay">GPay</option>
            <option value="Phonepe">Phonepe</option>
            <option value="Paytm">Paytm</option>
            <option value="credit card">credit card</option>
            <option value="UPI">UPI</option>
            <option value="Cash">Cash</option>
          </select>
        </div>
        <div class="col-md-3">
          <label class="form-label">Payment Type<sup><span class="text-danger font-12">*</span></sup>
            :</label>
          <input type="text" class="form-control form-control-sm" v-model="Obj.Type" />
        </div>
        
        <div class="col-md-3">
          <label class="form-label">Note :</label>
          <input type="text" class="form-control form-control-sm" v-model="Obj.Note" />
        </div>
        <div class="col-md-3 mt-4">
          <label class="form-label">Image :</label>
            <label for="fileInput" class="attachment-icon" > <i class="fa fa-upload"></i> </label>
          <input class="form-control" id="fileInput" type="file" multiple accept=".png,.jpg,.jpeg,.webp,.pdf,.docx,.doc,.xls,.txt" @change="UploadImg" />
           <div class="d-flex align-items-start">
          <a v-if="Obj.Image" :href="getUrl(Obj.Image)" target="_blank"  class="clearfix">{{Obj.Image.substring(Obj.Image.lastIndexOf('/') + 1)  }} </a>
          <i role="button" v-if="Obj.Image !== ''" @click="deleteFile(Obj.Image)" class="fa-solid fa-x text-danger f-5 mt-2 ms-1"></i>
        </div></div>     
        <div class="col-md-12 mt-5 text-end">
          <button class="btn btn-sm btn-darknavy me-1" @click="save()"> <i class="fa fa-save"></i> Save </button>
           <button type="button" class="btn btn-sm btn-soft-dark" @click="reset()"><i class="fa fa-times-circle  me-1"></i> Cancel</button>
        </div>
      </div>
        <ul v-if="errors.length" class="text-danger ps-3">
          <li v-for="(err, index) in errors" :key="index">{{ err }}</li>
        </ul>
      <hr />
      <div class="col-md-12 row g-3 mb-3">
          <div class="col-md-3">
            <label class="form-label">
              Class<sup><span class="text-danger font-12">*</span></sup> :
            </label>
            <div class="dropdown">
              <button class="form-select form-select-sm rounded dropdown-toggle w-100 dropdown-a"  type="button" data-bs-toggle="dropdown" aria-expanded="false">
                {{ clsList.find(c => c._id === collectObj.ClassId)?.name || "" }}
              </button>
              <ul class="dropdown-menu w-100 scrollable-menu" >
                <li v-for="(item, index) in uniqueClsList" :key="index">
                  <a class="dropdown-item" href="#" @click.prevent="collectObj.ClassId = item._id" >
                    {{ item.name }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        <div class="col-md-3">
          <label class="form-label">Section<sup><span class="text-danger font-12">*</span></sup> :</label>
          <select class="form-select form-select-sm rounded cursor-pointer" role="button" v-model="collectObj.sectionID" @change="listData1">
            <option selected=""></option>
            <option v-for="(item, index) in
              secList" :key="index" :value="item._id"> {{ item.Name }} </option>
          </select>
        </div>
         <div class="col-md-3">
          <label class="form-label">Student Name<sup><span class="text-danger font-12">*</span></sup>
            :</label>
          <select v-model="collectObj.studentID" class="form-select form-select-sm rounded cursor-pointer" role="button">
            <option selected=""></option>
            <option v-for="(item, index) in
              List2" :key="index" :value="item._id"> {{ item.firstName }}  {{ item.lastName }} </option>
          </select>
        </div>
        <div class="col-md-3 text-start mt-5">
          <button class="btn btn-sm btn-success text-center me-1" @click="searchrows()"> <i class="fa fa-search text-white me-1"></i> Go </button>
           <button type="button" class="btn btn-sm btn-soft-dark" @click="clear()"><i class="fa fa-times-circle  me-1"></i> Clear</button>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 table-responsive mt-2">
          <div class="progress mb-0 progress-sm" v-if="progress!=0">
        <div class="progress-bar" role="progressbar" :aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100"
          :style="{ width: progress + '%' }"></div>
      </div>
           <DataTable  v-if="progress==0" :columns="cols" :rows="rows" :pageSize="10"   :actions="{  edit: handleEdit, delete: handleDelete, showRow }" />
        </div>
      </div>
    </div>
  </div>
   <div v-if="showModal" class="modal fade show d-block" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-dialog-centered modal-lg modal-fullscreen-sm-down" role="document">
    <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title txt-darkblue">Student Payment Details</h5>
          <button type="button" class="btn-close ms-auto" data-dismiss="modal" aria-label="Close" @click="closeModal"></button>
        </div>
        <div class="modal-body" ref="modalTable">
          <div class="col-md-12 text-end">
            <i class="fa fa-print text-primary cursor-pointer fs-4 me-1" role="button" @click="print"></i>
            <i class="fa fa-download fs-4 me-2 cursor-pointer" role="button" @click="downloadModalContent('total')"></i>
          </div>
          <div class="col-md-12 table-responsive">
            <table class="table table-bordered custom-table text-nowrap ">
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Trans_ID</th>
                  <th>Fee Type</th>
                  <th>Amount</th>
                  <th>Date</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="(entry, idx) in selectedStudentTransactions" :key="idx">
                  <template v-for="(history, hIdx) in entry.History" :key="`${idx}-h-${hIdx}`">
                    <tr v-for="(fee, feeIdx) in parseFeeType(history.FeeType)" :key="`${idx}-${hIdx}-${feeIdx}`">
                      <td>{{ getSerialNumber(entry, hIdx, feeIdx) }}</td>
                      <td>{{ history.transID }}</td>
                      <td>{{ fee.Name }}</td>
                      <td>{{ fee.Amount }}</td>
                      <td>{{ disDate(history.PayDate) }}</td>
                      <td> <i class="fa fa-print text-primary cursor-pointer me-1" role="button"
                        @click="printReceipt(entry, fee, history)"></i>
                      <i class="fa fa-download cursor-pointer" role="button"
                        @click="downloadReceipt(entry, fee, history)"></i></td>
                    </tr>
                  </template>
                </template>
              </tbody>
            </table>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-sm btn-info text-white" @click="closeModal">Close</button>
        </div></div></div></div>
  <div ref="modalContent" class="invisible-content">
    <div class="card w-50">
      <div class="card-body">
        <div class="text-gray-800">
            <div class="d-flex justify-content-center align-items-center text-center">
            <img :src="getUrl(profile && profile.Image, logo_default)" alt="School Logo" width="100" height="100" class="me-2 mb-3"/>
            <div class="me-5 mb-4 mt-55">
              <h2 class="fw-bold mb-0">{{ profile && profile.Name }}</h2>
              <p class="mb-0 small ">{{ profile && profile.Address }}</p>
              <p class="mb-0 small  ">{{ profile && profile.Email }}</p>
              <p class="mb-0 small ">+91 {{ profile && profile.MobileNo }}</p>
            </div>
          </div>
          <hr />
          <h4 class="fw-bold text-center text-decoration-underline mb-0">Fee Receipt</h4>
          <div class="d-flex justify-content-between mb-0">
            <div>
              <p class="mb-1"><strong>Date:</strong> {{formattedCurrentDate }}</p>
              <p class="mb-1"><strong>Student:</strong> {{ Obj.studentName}}</p>
              <p><strong>Payment Mode:</strong> {{ Obj.PaymentMode }}</p>
            </div>
            <div class="text-end">
              <p class="mb-1"><strong>Class:</strong> {{clsList.find(cls => cls._id === Obj.ClassId)?.name || ''}} ({{secList.find(sec => sec._id === Obj.sectionID)?.Name || ''}}) </p>
              <div v-for="(h, i) in Obj.FeeType" :key="i">
              <p v-if="hidepaydate"><strong>Pay Date :</strong> {{ disDate(h.PayDate) }}</p>
            </div>
            </div>
          </div>
         <table class="w-100 mb-4 border">
         <thead>
         <tr class="bg-gray-200 text-left">
         <th class="p-2 border">S.No</th>
         <th class="p-2 border">Fee Type</th>
         <th class="p-2 border">Amount</th>
        </tr>
        </thead>
      <tbody>
       <tr v-for="(item, index) in Obj.FeeType" :key="index">
        <td class="p-2 border">{{ index + 1 }}</td>
        <td class="p-2 border">{{ item.Name }}</td>
        <td class="p-2 border">₹{{ item.Amount }}</td>
       </tr>
     </tbody>
     </table>
      <div class=" mb-3 d-flex justify-content-end align-items-center">
        <span class="fw-bold border p-2 border-secondary">Net Amount Payable:</span>
        <span class=" border p-2 border-secondary">₹{{Obj.PaidAmount }}</span>
      </div> 
      <div class="text-end mt-5">
        <p class="mb-1" style="margin-top:10rem;">....................................................</p>
        <small>(Signature of the person issuing the receipt)</small>
      </div>
        </div>
      </div>
    </div>
  </div>
  <DelPopup :name="delObj.PaymentMode" @delRecord="delRecord" @closeModal="delObj.PaymentMode = ''"> </DelPopup>
</template>
<script setup>
import AlertMsg from "@/components/Common/AlertMsg.vue";
import DelPopup from "@/components/Common/DelPopup.vue";
import DataTable from "@/components/Common/DataTable.vue";
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import { isRequired, validateForm } from "@/utils/validation.js";
import { useFileUpload } from "@/utils/fileUpload";
const { handleFileUploadImg } = useFileUpload();
import { formatDate, curdStatus, api } from '@/utils/helpers.js';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { nextTick } from 'vue';
import { ref, onMounted, computed, watch} from 'vue'
import { schoolStore } from '@/utils/schoolStore';
const { clsList,uniqueClsList, secList, profile } = schoolStore();
const modalTable = ref(null);
const modalContent = ref(null);
  const  Obj = ref( { transID: "", studentID: "", ClassId: "", sectionID: "", PayDate: new Date().toISOString().slice(0, 10), Total: "", PaymentMode: "", Note: "", Type: "", PaidAmount: "", Image: "",PaidType:"",FeeType:[], })
  const List1= ref([])
  const List2= ref([])
  const logo_default = "/images/Logo.png"
  const  Students= ref([])
  const  collectObj = ref({ClassId:"", sectionID:"", studentID:"",})
  const  selectedStudentTransactions= ref([])
  const feeOptions= ref([])           
  const allFeeOptions = ref([]);      
  const   msgObj= ref({ msg: "", role: "", show: false, })
  const   delObj = ref({})
  const   errors= ref({})
  const feeGroups = ref([]); 
  const showModal = ref(false)
  const rows = ref([])
  const hidepaydate= ref(false)
const cols=ref([
  { label: 'S.No', key: 'Sno' },
  { label: 'Trans ID', key: 'transID' },
  { label: 'Name', key: 'studentName' },
  { label: 'ScreenShot', key: 'Image', type:"image" },
  { label: 'Class', key: 'Class' },
  { label: 'Payment Mode', key: 'PaymentMode' },
  { label: 'Amount', key: 'PaidAmount', type:'rowData'},
  
]);        
const closeModal = () => {
  showModal.value = false
}
const handleEdit = async (row) => {
    Obj.value = { ...row, PayDate: row.PayDate ? row.PayDate.slice(0, 10) : new Date().toISOString().slice(0, 10),  }
      await api .get(`/students/clssection/${Obj.value.ClassId}/${Obj.value.sectionID}/`)
          .then(async(res) => { 
            List1.value = res.data 
            const res1 = await api.get(`/students/${ Obj.value.studentID}`);
            Obj.value.studentID =res1.data.student._id
          });
     if (Obj.value.Image?.startsWith(process.env.VUE_APP_API_URL)) {
    Obj.value.Image = Obj.value.Image.replace(process.env.VUE_APP_API_URL, '');
  }
  if (Obj.value.ClassId) {
    setFeeOptionsForClass(Obj.value.ClassId);
  }
}
const handleDelete = (row) => {
  delObj.value = { ...row };
}
const showRow = (row) => {
  selectedStudentTransactions.value = [row];
  showModal.value = true;
};
watch(
  () => Obj.value.FeeType,
  (newAmount) => {
    if (Array.isArray(newAmount)) {
      Obj.value.PaidAmount = newAmount.reduce((sum, fee) => sum + Number(fee.Amount || 0), 0);
    } else {
      Obj.value.PaidAmount = 0;
    }
  },
  { deep: true, immediate: true }
);
const extractClassId = (cls) => {
  if (!cls) return "";
  if (typeof cls === "string") return cls;
  if (typeof cls === "object") return cls._id || cls.id || cls.$oid || "";
  return "";
};
const setFeeOptionsForClass = (classId) => {
  if (!classId) return;
  const matchedGroup = feeGroups.value.find(g => {
    const gId = extractClassId(g.ClassName);
    return String(gId).trim() === String(classId).trim();
  });
  if (!matchedGroup) {
    feeOptions.value = [];
    allFeeOptions.value = [];
    Obj.value.FeeType = [];
    Obj.value.Total = 0;
    return;
  }
  let feeArr = matchedGroup.FeeType;
  if (typeof feeArr === "string") {
    try { feeArr = JSON.parse(feeArr); } catch { feeArr = []; }
  }
  if (Array.isArray(feeArr)) feeArr = feeArr.flat(Infinity);
  else feeArr = [];
  const fees = feeArr.filter(f => f && f.Name).map(f => ({
    Name: f.Name,
    Amount: f.Amount || 0
  }));
  feeOptions.value = [...fees];
  allFeeOptions.value = [...fees];
  Obj.value.FeeType = [...fees];
  Obj.value.Total = fees.reduce((sum, f) => sum + Number(f.Amount || 0), 0);
};
const onClassSelected = (fg) => {
  const classId = extractClassId(fg.ClassName);
  Obj.value.ClassId = classId;
  setFeeOptionsForClass(classId);
  Obj.value.studentID = "";
};
const disDate= (d)=> { return formatDate(d) }
const filterPaidFees = async () => {
  if (!Obj.value.studentID) return;
  try {
    const res = await api.get(`/Collect/all`); 
    const studentData = res.data.filter(r => r.studentID === Obj.value.studentID);
    const paidFees = new Set();
    studentData.forEach(record => {
      record.History?.forEach(h => { h.FeeType?.forEach(f => paidFees.add(f.Name)); });
    });
    const unpaidFees = allFeeOptions.value.filter( fee => !paidFees.has(fee.Name) );
    feeOptions.value = unpaidFees;
    Obj.value.FeeType = unpaidFees.map(fee => ({
      Name: fee.Name,
      Amount: fee.Amount
    }));
  } catch (err) {
    return;
  }
};
watch(() => Obj.value.studentID, async (newVal) => {
  if (newVal && Obj.value.ClassId) {
    setFeeOptionsForClass(Obj.value.ClassId);
    await filterPaidFees();
  }
});
const parseFeeType = (feeType) => {
  if (!feeType) return [];
  try {return typeof feeType === 'string' ? JSON.parse(feeType) : feeType; }
  catch { return []; }
};
const formattedCurrentDate = computed(() => {
  const today = new Date()
  return today.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })
})
const loadFeeGroups = async () => {
  try {
    const res = await api.get('/feesgroup/all');
    feeGroups.value = Array.isArray(res.data) ? res.data : [];
  } catch (err) {
    console.error("Error loading fee groups", err);
    feeGroups.value = [];
  }
};
const searchrows = () => {
  const filtered = rows.value.filter(row =>
    row.ClassId === collectObj.value.ClassId &&
    row.sectionID === collectObj.value.sectionID &&
    row.studentID === collectObj.value.studentID
  );
  rows.value = filtered;
};
const getSerialNumber = (entry, hIdx, feeIdx) => {
  let offset = 0;
  for (let i = 0; i < hIdx; i++) {
    const prevHistory = entry.History[i];
    if (prevHistory && prevHistory.FeeType) {
      const fees = parseFeeType(prevHistory.FeeType);
      offset += fees.length;
    }
  }
  return offset + feeIdx + 1;
};
const UploadImg = async (event) => {
  const file = event.target.files[0];
  if (!file) return;
const { file: uploadedFile, message } = await handleFileUploadImg(file);
  if (message) {
    msgObj.value = { msg: message, role: "danger", show: true };
    event.target.value = ""; 
    return;
  }
  if (uploadedFile) { Obj.value.Image = uploadedFile; }
  event.target.value = null;
};
const printReceipt = async (entry, fee, history) => {
  Obj.value = {
    ...entry,
    FeeType: [{ ...fee, PayDate: history.PayDate }], 
    PaidAmount: fee.Amount || 0,
  };
  hidepaydate.value=true;
  await nextTick();
  printcontent();
};
const downloadReceipt = async (entry, fee, history) => {
  Obj.value = {
    ...entry,
    FeeType: [{ ...fee, PayDate: history.PayDate }], 
    PaidAmount: fee.Amount || 0,
  };
  hidepaydate.value=true;
  await nextTick();
  downloadModalContent("single");
};
const print = async () => {
  if (!selectedStudentTransactions.value.length) return;

  const entry = selectedStudentTransactions.value[0];
  let allFees = [];
  entry.History?.forEach(history => {
    const feeTypeList = parseFeeType(history.FeeType);
    feeTypeList.forEach(fee => {
      allFees.push({
        ...fee,
        transID: history.transID,
        PayDate: history.PayDate
      });
    });
  });

  Obj.value = {
    ...entry,
    FeeType: allFees,
    PaidAmount: allFees.reduce((sum, fee) => sum + Number(fee.Amount || 0), 0),
  };
  hidepaydate.value=false;
  await nextTick();
  printcontent();
};
const printcontent = async() => {
      const printContent = modalContent.value?.innerHTML;
      const printWindow = window.open('', '', 'width=900,height=900');
      printWindow.document.write(`
      <html>
        <head>
          <style>
           @page { size: portrait; }
            body { font-family: Arial, sans-serif; padding: 20px; }
            .border { border: 1px solid #ccc; }
            .card { width: 70%; margin: auto; border: 1px solid #ccc; padding: 20px; border-radius:5px; }
            .p-2 { padding: 0.5rem; }
            h3{font-size:50px;} .mt-55{margin-top:-45px;}
            .mb-0{margin-bottom:-10px;}
            .mb-1 { margin-bottom: 0.25rem; }
            .mb-3 { margin-bottom: 1rem; }
            .text-end { text-align: end; }
            .text-decoration-underline{text-decoration: underline;}
            .fw-bold { font-weight: bold; }
            .text-center { text-align: center; }
            .text-muted { color: #6c757d; }
            .d-flex { display: flex; }
            .justify-content-between { justify-content: space-between; }
            .justify-content-end { justify-content: flex-end; }
            .align-items-center { align-items: center; }
            .w-100 { width: 100%; }
            .border-secondary { border-color: #6c757d !important; }
            hr { margin: 1rem 0; }
            table { border-collapse: collapse; width: 100%; }
            th, td { border: 1px solid #ccc; padding: 8px; }
            img { max-width: 140px!important; height: 120px!important; margin-left:50px;}
          </style>
        </head>
        <body onload="window.print(); window.close();">
          ${printContent}
        </body>
      </html>
    `);
      printWindow.document.close();
    }
const downloadModalContent = async (type = "total") => {
  const modalElement = modalContent.value;

  const entry = selectedStudentTransactions.value[0];
  if (!entry) return;

  if (type === "total") {
    let allFees = [];

    entry.History?.forEach(history => {
      const feeTypeList = parseFeeType(history.FeeType);
      feeTypeList.forEach(fee => {
        allFees.push({
          ...fee,
          transID: history.transID,
          PayDate: history.PayDate
        });
      });
    });

    Obj.value = {
      ...entry,
      FeeType: allFees,
      PaidAmount: allFees.reduce((sum, fee) => sum + Number(fee.Amount || 0), 0),
    };

    hidepaydate.value = false;
  }
  await nextTick();

  try {
    const canvas = await html2canvas(modalElement, { scale: 2, useCORS: true });
    const imgData = canvas.toDataURL('image/png');
    const pdf = new jsPDF({
      orientation: 'portrait',
      unit: 'px',
      format: [canvas.width, canvas.height],
    });
    pdf.addImage(imgData, 'PNG', 0, 0, canvas.width, canvas.height);
    pdf.save('Fees-receipt.pdf');
  } catch (error) {
    console.error('Error generating PDF:', error);
  }
};

const loadStudents= async() => {
  const res = await api.get(`/students/search`);
  Students.value = res.data;
  await loadData();
}
const listData = async () => {
  if (!Obj.value.ClassId || !Obj.value.sectionID) return;
  const res = await api.get(`/students/clssection/${Obj.value.ClassId}/${Obj.value.sectionID}/`);
  List1.value = res.data;
  if (Obj.value.studentID) {
    setFeeOptionsForClass(Obj.value.ClassId);
    await filterPaidFees();
  }
};
const listData1 = async() => {
  await api .get(`/students/clssection/${collectObj.value.ClassId}/${collectObj.value.sectionID}/`)
    .then((res) => { List2.value = res.data });
}
    const save= async() => {
      const fields = {
        Class: { value: Obj.value.ClassId, validators: [isRequired], },
        Section: { value: Obj.value.sectionID, validators: [isRequired], },
        Student: { value: Obj.value.studentID, validators: [isRequired], },
        Total: { value: Obj.value.Total, validators: [isRequired], },
        PayableAmount: { value: Obj.value.PaidAmount, validators: [isRequired], },
        TransactionID: { value: Obj.value.transID, validators: [isRequired], },
        PaidType: { value: Obj.value.PaidType, validators: [isRequired], },
        FeeType: { value: Obj.value.FeeType, validators: [isRequired], },
        PaymentMode: { value: Obj.value.PaymentMode, validators: [isRequired], },
        PaymentType: { value: Obj.value.Type, validators: [isRequired], },
      };
      errors.value = validateForm(fields);
      if (Object.keys(errors.value).length === 0) {
        const { url, method, msg } = curdStatus(Obj.value);
        const payload = {
      ...Obj.value,
      History: [{
        PaidAmount: Obj.value.PaidAmount,
        FeeType: Obj.value.FeeType,
        transID: Obj.value.transID
      }]
    };
        await api[method](`/Collect${url}`,payload)
          .then(async() => { await loadStudents(); await loadData(); reset(); msgObj.value = { msg: `Collectfee ${msg} Successfuly`, role: "success", show: true, }; })
          .catch((error) => { console.log(error); }); }
    }
   const reset= async() => {
      Obj.value = { transID: "", studentID: "", ClassId: "", sectionID: "", PayDate: new Date().toISOString().slice(0, 10), Total: "", PaymentMode: "", Note: "", Type: "", PaidAmount: "", Image: "",PaidType:"", FeeType:[], };
      msgObj.value = { msg: "", role: "", show: false, };
      errors.value={};
      List1.value=[];
    }
    const clear = async () => {
  collectObj.value = { ClassId: "", sectionID: "", studentID: "" };
  await loadData(); 
};
 const progress = ref(0)
const loadData= async()=> {
      let direction = 1
     let progressInterval = setInterval(() => {
       progress.value += direction
       if (progress.value >= 100) {
         progress.value = 0 
       }
     }, 100)
  await api.get('/Collect/all')
  .then((response) => { rows.value = response.data.map((item, i) => ({  ...item, Sno: i + 1, Type: item.History?.[0]?.Type,
    transID: item.History?.[0].transID,PaidType: item.History?.[0].PaidType,
   PaidAmount: `${item.History?.[0]?.PaidAmount || ''} / ${item.Total || ''}`,
  Image: item.Image,
  Class: `${clsList.value.find(c => c._id === item.ClassId)?.name || ''}${clsList.value.find(c => c._id === item.ClassId)?.name ? (secList.value.find(s => s._id === item.sectionID)?.Name ? ' (' + secList.value.find(s => s._id === item.sectionID)?.Name + ')' : '') : ''}`,
  FeeType: (() => {
    try { return Array.isArray(item.History?.[0]?.FeeType) ? item.History?.[0]?.FeeType : JSON.parse(item.History?.[0]?.FeeType || '[]'); } 
    catch { return []; }})(),
}));
 rows.value.forEach(async(row)=>{
           await api .get(`/students/${row.studentID}`)
          .then((res) => { row.studentName = res.data.student.firstName + ' ' +res.data.student.lastName;
           });})
          List1.value = response.data;
    progress.value = 0
          clearInterval(progressInterval)
        });
    }
  const deleteFile = async (filePath) => {
      if (!filePath) return;
      const fileName = filePath.split('/').pop();

      try {
        await api.delete(`/documents/students?filename=${fileName}`);
        Obj.value.Image = '';
      } catch (err) {
        msgObj.value = { msg: 'Failed to delete image.', role: 'danger', show: true };
      }
    };
    const delRecord= async() => {
      await api.delete(`/Collect/${delObj.value._id}`)
     .then(() => { loadData(); delObj.value={}; msgObj.value = { msg: "Collectfee Deleted Successfuly.", role: "danger", show: true, }; });
    }
    const getUrl = (img, fallback) => {
  let imgUrl = !img
    ? fallback
    : img.startsWith("..")
      ? img.substring(2)
      : img;
  
  const base = process.env.VUE_APP_API_URL.replace(/\/+$/, "");
  const path = imgUrl.replace(/^\/+/, "");
  return `${base}/${path}`;
}
onMounted(async() => {  loadStudents(); loadData(); loadFeeGroups();
  try {
    const [feeGroupRes, classRes] = await Promise.all([
      api.get("/feesgroup/all"),
      api.get("/cls/all")
    ]);
    feeGroups.value = feeGroupRes.data || [];
    clsList.value = classRes.data || [];
  } catch (err) {
    console.error("Error fetching data:", err);
  }
 })
</script>
<style>
.invisible-content {
  position: absolute;
  left: -9999px;
  top: -9999px;
  width: 62.5rem;
  height: auto;
  overflow: visible;
  background: white;
  z-index: -1;
}

.attachment-icon {
  cursor: pointer;
  font-size: 20px;
  color: #333;
  padding: 5px;
  display: inline-block;
}
#fileInput {
  display: none;
}
.bs-example-modal-lg{
  background-color: rgb(17 17 18 / 50%) !important;
}
.modal-backdrop-div {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.6);
  display: flex !important;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.fade{
   background: rgba(0,0,0,0.6);
}
.modal-box {
  background: white;
  padding: 0px;
  border-radius: 8px;
  width: 900px;
}
</style>

